import { render, staticRenderFns } from "./GoalPlannerLogbookDialog.vue?vue&type=template&id=4bfb6130"
import script from "./GoalPlannerLogbookDialog.ts?vue&type=script&lang=ts&external"
export * from "./GoalPlannerLogbookDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./GoalPlannerLogbookDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports